"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryPatterns = exports.DictionaryPatternsSerializer = void 0;
// MIT © 2017 azu
var prototype_1 = require("@immutable-array/prototype");
var DictionaryPattern_1 = require("./DictionaryPattern");
exports.DictionaryPatternsSerializer = {
    fromJSON: function (patternStrings) {
        if (patternStrings === void 0) { patternStrings = []; }
        return new DictionaryPatterns(patternStrings.map(function (pattern) { return new DictionaryPattern_1.DictionaryPattern(pattern); }));
    },
    toJSON: function (entity) {
        return entity.getPatternValuesWithoutEmpty();
    }
};
/**
 * Collection of Patterns
 */
var DictionaryPatterns = /** @class */ (function () {
    function DictionaryPatterns(patterns) {
        this.patterns = patterns;
    }
    // read
    DictionaryPatterns.prototype.getPatterns = function () {
        return this.patterns;
    };
    DictionaryPatterns.prototype.getPatternValues = function () {
        return this.patterns.map(function (pattern) { return pattern.value; });
    };
    DictionaryPatterns.prototype.getPatternValuesWithoutEmpty = function () {
        return this.getPatternValues().filter(function (pattern) { return pattern.length > 0; });
    };
    // write
    DictionaryPatterns.prototype.add = function (pattern) {
        return new DictionaryPatterns(this.patterns.concat(pattern));
    };
    DictionaryPatterns.prototype.update = function (oldExpect, newExpect) {
        var index = this.patterns.findIndex(function (targetPattern) {
            return targetPattern.equals(oldExpect);
        });
        if (index === -1) {
            return this;
        }
        var dictionaryPatterns = prototype_1.splice(this.patterns, index, 1, newExpect);
        return new DictionaryPatterns(dictionaryPatterns);
    };
    DictionaryPatterns.prototype.remove = function (pattern) {
        var index = this.patterns.findIndex(function (targetPattern) {
            return targetPattern.equals(pattern);
        });
        if (index === -1) {
            return this;
        }
        return new DictionaryPatterns(prototype_1.splice(this.patterns, index, 1));
    };
    return DictionaryPatterns;
}());
exports.DictionaryPatterns = DictionaryPatterns;
//# sourceMappingURL=DictionaryPatterns.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionaryPatterns.js
// module id = 167
// module chunks = 0